import { ModalWindow, ArticleParagraph2, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import { Footer } from './inner/Footer';
import { EType } from '../../../types/villagePromotions';
interface IPromoDescriptionModalProps {
  name: string;
  open: boolean;
  subtitle: string;
  description?: string | null;
  promoType: EType;
  builderName?: string;
  logoUrl?: string;
  phoneNumber?: string;
  onClose(): void;
  handleOpenContactModal(): void;
}

export const PromoDescriptionModal = (props: IPromoDescriptionModalProps) => {
  return (
    <ModalWindow
      open={props.open}
      content={props.description && <ArticleParagraph1>{props.description}</ArticleParagraph1>}
      escape
      fixed={false}
      footer={
        <Footer
          authorLabel="Акция от застройщика"
          authorName={props.builderName}
          authorLogoUrl={props.logoUrl}
          isDescriptionModal
          handleOpenContactModal={props.handleOpenContactModal}
        />
      }
      header={props.subtitle && <ArticleParagraph2 color="gray60_100">{props.subtitle}</ArticleParagraph2>}
      maxWidth={728}
      onClose={props.onClose}
      outside
      size="M"
      title={props.name}
    />
  );
};

PromoDescriptionModal.displayName = 'PromoDescriptionModal';
